import { render } from "./exchangeDrawer.vue?vue&type=template&id=c4f02d86&scoped=true"
import script from "./exchangeDrawer.vue?vue&type=script&lang=js"
export * from "./exchangeDrawer.vue?vue&type=script&lang=js"

import "./exchangeDrawer.vue?vue&type=style&index=0&id=c4f02d86&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f02d86"]])

export default __exports__